import { axios } from '@/utils/request';

export function getFirmwareSchedules(params = {}) {
    const query = Object.keys(params)
        .filter(k => params[k] !== undefined && params[k] !== null && params[k] !== '')
        .map(k => `${k}=${encodeURIComponent(params[k])}`)
        .join('&');

    return axios({
        url: query ? `/firmware-schedules?${query}` : '/firmware-schedules',
        method: 'get'
    });
}

export function getFirmwareSchedule(id) {
    return axios({
        url: `/firmware-schedules/${id}`,
        method: 'get'
    });
}

export function createFirmwareSchedule(data) {
    return axios({
        url: '/firmware-schedules',
        method: 'post',
        data
    });
}

export function updateFirmwareSchedule(id, data) {
    return axios({
        url: `/firmware-schedules/${id}`,
        method: 'patch',
        data
    });
}

export function deleteFirmwareSchedule(id) {
    return axios({
        url: `/firmware-schedules/${id}`,
        method: 'delete'
    });
}

export function runFirmwareScheduleNow(id) {
    return axios({
        url: `/firmware-schedules/${id}/run-now`,
        method: 'post'
    });
}

export function getFirmwareScheduleRuns(id, params = {}) {
    const query = Object.keys(params)
        .filter(k => params[k] !== undefined && params[k] !== null && params[k] !== '')
        .map(k => `${k}=${encodeURIComponent(params[k])}`)
        .join('&');

    return axios({
        url: query ? `/firmware-schedules/${id}/runs?${query}` : `/firmware-schedules/${id}/runs`,
        method: 'get'
    });
}

export function resolveFirmwareScheduleBaseIds(baseIds) {
    return axios({
        url: '/firmware-schedules/resolve-base-ids',
        method: 'post',
        data: { base_ids: baseIds }
    });
}

export function checkFirmwareScheduleBaseOverlaps(baseIds, excludeScheduleId = null) {
    return axios({
        url: '/firmware-schedules/check-base-overlaps',
        method: 'post',
        data: {
            base_ids: baseIds,
            ...(excludeScheduleId ? { exclude_schedule_id: excludeScheduleId } : {})
        }
    });
}
